import axios from "../../axios";

const urlMeeting = "/student-meetings";
const urlLevelTest = "/student-level-tests";
const urlReport = "/report-meetings";
const state = {
  meetings: [],
  pagination: {
    current_page: 1,
    per_page: 100,
    total: 0,
  },
  levelTests: [],
  levelTestPagination: {
    current_page: 1,
    per_page: 10,
    total: 0,
  },
  allMeetings: [],
  allMeetingPagination: {
    current_page: 1,
    per_page: 100,
    total: 0,
  },
};

const actions = {
  /**
   * Get list meetings
   * @param commit
   * @param query
   * @returns {Promise<void>}
   */
  async getLists({ commit }, query) {
    try {
      const response = await axios.get(
        `${urlMeeting}?${new URLSearchParams(query)}`
      );
      if (response.status === 200) {
        commit("SET_LIST_MEETINGS", response.data.data);
      }
    } catch (e) {
      console.log("exception: ", e);
    }
  },

  async getAllMeetings({ commit }, query) {
    try {
      const response = await axios.get(
        `all-meetings?${new URLSearchParams(query)}`
      );
      if (response.status === 200) {
        commit("SET_LIST_ALL", response.data.data);
      }
    } catch (e) {
      console.log("exception: ", e);
    }
  },

  async getListLevelTests({ commit }, query) {
    try {
      const response = await axios.get(
        `${urlLevelTest}?${new URLSearchParams(query)}`
      );
      if (response.status === 200) {
        commit("SET_LIST_LEVEL_TESTS", response.data.data);
      }
    } catch (e) {
      console.log("exception: ", e);
    }
  },
  async getReport({ commit }, query) {
    try {
      const response = await axios.get(
        `${urlReport}?${new URLSearchParams(query)}`
      );
      const data = response.data.data;
      if (response.status === 200) {
        commit("SET_REPORT_MEETINGS", data);
      }
      return data;
    } catch (e) {
      console.log("exception: ", e);
    }
  },
  async update({ commit }, { id, payload }) {
    return await axios
      .put(`${urlMeeting}/${id}`, payload)
      .then((response) => {
        commit("UPDATE_MEETING", response.data.data);
      })
      .catch();
  },
  async updateLevelTest({ commit }, { id, payload }) {
    return await axios
      .put(`${urlLevelTest}/${id}`, payload)
      .then((response) => {
        commit("UPDATE_LEVEL_TEST", response.data.data);
      })
      .catch();
  },

  /**
   * set current page
   * @param commit
   * @param data
   */
  setCurrentPage({ commit }, data) {
    commit("SET_CURRENT_PAGE", data);
  },

  /**
   * set per page
   * @param commit
   * @param data
   */
  setPerPageLevelTest({ commit }, data) {
    commit("SET_PER_PAGE_LEVEL_TEST", data);
  },

  setCurrentPageLevelTest({ commit }, data) {
    commit("SET_CURRENT_PAGE_LEVEL_TEST", data);
  },

  setPerPageAllMeeting({ commit }, data) {
    commit("SET_PER_PAGE_ALL_MEETING", data);
  },

  setCurrentPageAllMeeting({ commit }, data) {
    commit("SET_CURRENT_PAGE_ALL_MEETING", data);
  },

  setPerPage({ commit }, data) {
    commit("SET_PER_PAGE", data);
  },
};

const mutations = {
  SET_LIST_ALL(state, data) {
    state.allMeetings = data.data;
    state.allMeetingPagination.from = data.from;
    state.allMeetingPagination.to = data.to;
    state.allMeetingPagination.total = data.total;
    state.allMeetingPagination.current_page = data.current_page;
    state.allMeetingPagination.per_page = data.per_page;
  },
  SET_LIST_MEETINGS(state, data) {
    state.meetings = data.data;
    state.pagination.from = data.from;
    state.pagination.to = data.to;
    state.pagination.total = data.total;
    state.pagination.current_page = data.current_page;
    state.pagination.per_page = data.per_page;
  },
  SET_LIST_LEVEL_TESTS(state, data) {
    state.levelTests = data.data;
    state.levelTestPagination.from = data.from;
    state.levelTestPagination.to = data.to;
    state.levelTestPagination.total = data.total;
    state.levelTestPagination.current_page = data.current_page;
    state.levelTestPagination.per_page = data.per_page;
  },
  SET_REPORT_MEETINGS(state, data) {
    state.report = data;
  },
  SET_CURRENT_PAGE(state, data) {
    state.pagination.current_page = data;
  },
  SET_PER_PAGE(state, data) {
    state.pagination.per_page = data;
  },
  SET_PER_PAGE_LEVEL_TEST(state, data) {
    state.levelTestPagination.per_page = data;
  },
  SET_CURRENT_PAGE_LEVEL_TEST(state, data) {
    state.levelTestPagination.current_page = data;
  },
  SET_PER_PAGE_ALL_MEETING(state, data) {
    state.allMeetingPagination.per_page = data;
  },
  SET_CURRENT_PAGE_ALL_MEETING(state, data) {
    state.allMeetingPagination.current_page = data;
  },
  UPDATE_MEETING(state, data) {
    const pos = state.meetings
      .map(function (e) {
        return e.id;
      })
      .indexOf(data.id);
    state.meetings.splice(pos, 1, data);
  },
  UPDATE_LEVEL_TEST(state, data) {
    const pos = state.levelTests
      .map(function (e) {
        return e.id;
      })
      .indexOf(data.id);
    state.levelTests.splice(pos, 1, data);
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
